export default "__VITE_ASSET__BM8JHs4X__"